module.exports = __webpack_public_path__ + "static/020-a7f095d2e9262665fec5e7820df84a04.jpg";